import * as React from "react";
import { SVGProps } from "react";
function SvgFileTypeDocIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 29H6v-9h2v7h16v-7h2v9ZM6 2h20v9h-2V4H8v7H6V2Z"
        fill="#4B8DF0"
      />
      <path
        d="M7.917 12.7h2.277c.774 0 1.383.234 1.827.702.45.462.675 1.146.675 2.052v.72c0 .942-.225 1.65-.675 2.124-.444.468-1.053.702-1.827.702H7.917v-6.3Zm2.277 5.229c.378 0 .675-.135.891-.405.216-.27.324-.72.324-1.35v-.72c0-.594-.108-1.023-.324-1.287-.216-.264-.513-.396-.89-.396h-.99v4.158h.99Zm5.941 1.152c-.774 0-1.386-.24-1.836-.72-.444-.486-.665-1.23-.665-2.232v-.72c0-.918.221-1.611.665-2.079.45-.474 1.063-.711 1.837-.711s1.383.237 1.826.711c.45.468.675 1.161.675 2.079v.72c0 1.002-.224 1.746-.675 2.232-.444.48-1.052.72-1.826.72Zm0-1.107c.186 0 .354-.03.505-.09a.835.835 0 0 0 .386-.306c.102-.144.18-.333.235-.567.06-.24.09-.534.09-.882v-.72c0-.606-.108-1.038-.325-1.296-.215-.258-.512-.387-.89-.387s-.675.129-.891.387c-.216.258-.324.69-.324 1.296v.72c0 .348.027.642.08.882.06.234.142.423.244.567a.843.843 0 0 0 .378.306c.15.06.32.09.513.09Zm5.942 1.107c-.774 0-1.386-.243-1.836-.729-.444-.486-.666-1.23-.666-2.232v-.72c0-.912.222-1.602.666-2.07.45-.474 1.062-.711 1.836-.711.372 0 .699.048.98.144.283.096.523.234.72.414.199.18.355.399.469.657.114.252.189.537.225.855h-1.287c-.054-.306-.165-.543-.333-.711-.168-.168-.426-.252-.774-.252-.378 0-.675.129-.891.387-.216.252-.324.681-.324 1.287v.72c0 .348.027.642.08.882.06.234.142.423.244.567a.907.907 0 0 0 .378.315c.15.06.32.09.513.09.354 0 .609-.084.765-.252.162-.174.276-.426.342-.756h1.287c-.078.672-.312 1.194-.702 1.566-.39.366-.954.549-1.692.549Z"
        fill="#4B8DF0"
      />
    </svg>
  );
}
export default SvgFileTypeDocIcon;
